import { TMSScanOrderVo } from "@/types";
import { Descriptions } from "antd";
import { DescriptionsItemProps } from "antd/es/descriptions/Item";
import { useMemo } from "react";

interface BasicInfoProps {
  className?: string;
  order: TMSScanOrderVo;
}
export function BasicInfo(props: BasicInfoProps) {
  const { order } = props;
  const infoItems = useMemo(() => {
    const hasVCInfo = order.scanConfig.isSSCCOrder;
    const items: DescriptionsItemProps[] = [
      {
        label: "RII Order No.",
        children: order.riiOrderNo,
      },
      {
        label: "Customer",
        children: order.customer,
      },
    ];
    // get address of first group
    const firstGroup = order.groups[0];
    if (firstGroup != null && firstGroup.address != null) {
      const address = firstGroup.address;
      items.push({
        label: "Address",
        children: (
          <div>
            <span>{address.street} </span>
            <span>
              {address.city}, {address.state} {address.zip}
            </span>
          </div>
        ),
      });
    }
    if (hasVCInfo) {
      items.push(
        ...[
          {
            label: "Platform",
            children: order.vcInfo.type,
          },
          {
            label: "Carrier Name",
            children: order.vcInfo.carrierName,
          },
          {
            label: "BOL No.",
            children: order.vcInfo.bolNo,
          },
          {
            label: "PO No.",
            children: order.vcInfo.poNo,
          },
        ],
      );
    }
    return items;
  }, [order]);

  return (
    <Descriptions
      column={2}
      size="small"
      bordered
      items={infoItems}
      styles={{
        label: { width: "16%" },
        content: { width: "36%" },
      }}
    />
  );
}
